import Korean from "../../assets/images/flagTire.png"
export default function TireCard(props) {

    const listTypeOfTire = [
        {
            name: 'Korean',
            rarePercent: 0.08,
            minted: 84,
            price: 123456789,
            img: Korean
        },
        {
            name: 'Korean',
            rarePercent: 0.08,
            minted: 84,
            price: 123456789,
            img: Korean
        }, {
            name: 'Korean',
            rarePercent: 0.08,
            minted: 84,
            price: 123456789,
            img: Korean
        }
    ]
    return (
        <>
            <div className="relative w-full border-x-[1rem] border-x-transparent ">
                {/* <p className="text-[3.2rem] font-bakbak text-white absolute top-[2rem] left-[5rem]">Tire 1</p> */}
                {/* <p className="text-[2rem] font-bakbak text-white absolute top-[10rem] right-[10rem]">Rarity</p> */}
                <div className="absolute w-[33rem] top-[10rem] left-[2rem]">
                    {props.countryOfTier.map((item, index) => (
                        <div key={index} className="mb-[2rem] w-full">
                            <TypeOfTireItem name={item.name}
                                rarePercent={props.mintedRatio}
                                minted={item.minted}
                                price={12233141242}
                                img={item.img} />
                        </div>
                    ))}
                </div>
                {
                    props.box
                }
            </div>
        </>
    )
}

function TypeOfTireItem(props) {
    return (
        <>
            <div className="w-full flex justify-between items-center">
                <div className="flex justify-between ">
                    <div className="w-[6rem] h-[4rem] mr-[1.4rem]">
                        <img src={props.img} alt="flag tire" />
                    </div>
                    <div className="">
                        <p className="leading-[2.4rem] text-white text-[1.6rem] font-bakbak">{props.name}</p>
                        <p className="leading-[2.4rem] text-white opacity-50 text-[1.6rem] font-bakbak">Minted: {props.minted}</p>
                    </div>
                </div>


                <div className="flex flex-col items-end">
                    <p className="leading-[2.4rem] text-white text-[1.6rem] font-bakbak">{props.rarePercent}%</p>
                    <p className="leading-[2.4rem] text-white opacity-50 text-[1.6rem] font-bakbak">~${props.price}</p>
                </div>
            </div>
        </>
    )
}